import "./Parametre.css";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { UpdatePassword } from "../../Auth/authServices";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { FaEyeSlash, FaFacebook } from "react-icons/fa";
import {
  getDocument,
  linkWithFacebook,
  facebookProviderStatus,
  unLinkedWhithFacebook,
  onDeleteUser,
} from "../../../Firebase";
import { CgDanger } from "react-icons/cg";
import { AiFillEye } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import MonBtn from "../../Commun/Btnbtn/MonBtn";

function Parametre() {
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShowns, setPasswordShowns] = useState(false);
  const [passwordShowne, setPasswordShowne] = useState(false);
  const userCurrent = JSON.parse(sessionStorage.getItem("user"));
  const navigate = useNavigate();

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const togglePasswordVisiblitys = () => {
    setPasswordShowns(passwordShowns ? false : true);
  };

  const togglePasswordVisiblitye = () => {
    setPasswordShowne(passwordShowne ? false : true);
  };

  const { register, handleSubmit, reset , formState: { errors }, } = useForm();
  const [currentUser, setCurrentUser] = useState({});
  const [facebookAccountStatus, setFacebookAcountStatus] = useState(false);

  const onSubmit = (data) => {
    const { actualPassword, newPassword, confirmPassword } = data;
    if (newPassword === confirmPassword) {
      UpdatePassword(newPassword);
      reset();
    } else {
      toast.error("Mots de passe ne correspond pas");
    }
  };

  useEffect(() => {
    const currentUserId = sessionStorage.getItem("user_id");
    getDocument("users", currentUserId, setCurrentUser);
    facebookProviderStatus(userCurrent.email, setFacebookAcountStatus);
  }, []);
  return (
    <div className="parametre">
      <div className="mx-auto pb-5 w-lg-50">
        <Container>
          <Row>
            <div className="d-flex justify-content-end ajouRecher  ">
              <MonBtn style={{ backgroundColor: "blue" }} children />
            </div>
            <h3>Modifier votre mot de passe</h3>
            <Col>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="passwordLablel"
                >
                  <Form.Label>Actuel mot de passe</Form.Label>
                  <Form.Control
                    {...register("actualPassword", { require: true, minLength: 6 })}
                    type={passwordShown ? "text" : "password"}
                    placeholder="Entrer l'actuel mot de passe"
                  />
                  {passwordShown === false ? (
                    <AiFillEye
                      className="position-absolute eye"
                      onClick={togglePasswordVisiblity}
                      size={20}
                    />
                  ) : (
                    <FaEyeSlash
                      className="position-absolute eye"
                      onClick={togglePasswordVisiblity}
                      size={20}
                    />
                  )}
                   {errors?.actualPassword?.type === "minLength" && (
                      <p className="text-danger">le mot de pass doit avoir au moin 6 caractères</p>
                    )}
                </Form.Group>

                <Form.Group
                  className="mb-3 position-relative"
                  controlId="newPasswordLabel"
                >
                  <Form.Label>Nouveau mot de passe</Form.Label>
                  <Form.Control
                    {...register("newPassword", { require: true, minLength: 6 })}
                    type={passwordShowns ? "text" : "password"}
                    placeholder="Entrer le nouveau mot de passe"
                  />
                  {passwordShowns === false ? (
                    <AiFillEye
                      className="position-absolute eye"
                      onClick={togglePasswordVisiblitys}
                      size={20}
                    />
                  ) : (
                    <FaEyeSlash
                      className="position-absolute eye"
                      onClick={togglePasswordVisiblitys}
                      size={20}
                    />
                  )}
                  {errors?.newPassword?.type === "minLength" && (
                      <p className="text-danger">le mot de pass doit avoir au moin 6 caractères</p>
                    )}
                </Form.Group>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="confirmPasswordLabel"
                >
                  <Form.Label>Confirmation mot de passe</Form.Label>
                  <Form.Control
                    {...register("confirmPassword", { require: true, minLength: 6 })}
                    type={passwordShowne ? "text" : "password"}
                    placeholder="Confirmer le nouveau mot de passe !"
                  />
                  {passwordShowne === false ? (
                    <AiFillEye
                      className="position-absolute eye"
                      onClick={togglePasswordVisiblitye}
                      size={20}
                    />
                  ) : (
                    <FaEyeSlash
                      className="position-absolute eye"
                      onClick={togglePasswordVisiblitye}
                      size={20}
                    />
                  )}
                  {errors?.confirmPassword?.type === "minLength" && (
                      <p className="text-danger">le mot de pass doit avoir au moin 6 caractères</p>
                    )}
                </Form.Group>
                <div className="text-end">
                  <Button
                    className="btn btn-lg block-btn1 border-danger text-white me-4"
                    onClick={() => navigate(-1)}
                    variant="danger"
                  >
                    Annuler
                  </Button>
                  <button type="submit" className="btn btn-lg block-btn1">
                    Enregistrer
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={6}>
              <h3>
                {facebookAccountStatus === false ? "Associer" : "Dissocier"} mon
                compte à Facebook
              </h3>
              {facebookAccountStatus === false ? (
                <p>
                  Une fois votre compte associer, Vous pourez dorenavant vous
                  connectez facilement à Facebook!
                </p>
              ) : (
                <p>
                  Quand vous Dissocier votre compte, Vous ne pourez dorenavant
                  pas vous connectez à partir de facebook !
                </p>
              )}
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              {facebookAccountStatus === false ? (
                <button
                  onClick={() => {
                    linkWithFacebook();
                  }}
                  className="block-btn btn btn-lg"
                >
                  <span>Associer maintenant </span>
                  <FaFacebook />
                </button>
              ) : (
                <button
                  className="btn btn-lg btn-danger"
                  onClick={() => {
                    unLinkedWhithFacebook();
                  }}
                >
                  <span>Dissocier maintenant </span>
                  <FaFacebook />
                </button>
              )}
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={6}>
              <h3>Supprimer mon compte</h3>
              <p>
                Quand vous supprimer votre compte, vous perdrez votre compte
                ainsi que toutes les données associer à votre compte.
              </p>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              <button
                onClick={() => {
                  onDeleteUser();
                }}
                className="btn btn-lg btn-danger"
              >
                <CgDanger />
                Supprimer
                <CgDanger />
              </button>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Parametre;
